<template>
  <!-- 注册 -->
  <div class="sign-box sign-up">
    <div class="rounded box-shadow bg-white p-4 w-100 translate">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="h4 font-weight-bold">Sign up</h4>
        <a href="#login-box" data-login="close"
          ><i class="icon-style icon-xs style-close"></i
        ></a>
      </div>
      <div class="pt-4">
        <my-input v-model="email" placeholder="Email"></my-input>
        <my-input
          v-model="password"
          type="password"
          placeholder="Password"
        ></my-input>
        <my-input
          v-model="rePassword"
          type="password"
          :err-msg="errMsg"
          placeholder="Confirm Password"
        ></my-input>
        <div class="form-group">
          <div class="form-check">
            <input
              v-model="agree"
              class="form-check-input"
              type="checkbox"
              id="check-accept"
            />
            <label class="form-check-label" for="check-accept">
              I accept the
              <router-link to="/terms" class="text-primary"
                >Terms of service</router-link
              >
              and
              <router-link to="/privacy-policy" class="text-primary"
                >Privacy policy</router-link
              >
            </label>
          </div>
        </div>
        <div class="py-2">
          <button
            type="button"
            class="btn btn-primary d-block w-100"
            @click="signUp"
          >
            Sign up now
          </button>
        </div>
        <div class="py-2">
          <a
            id="sign-up2sign-in"
            href="#login-box"
            data-login=".sign-in"
            class="btn btn-outline-secondary d-block"
            >Sign in</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../../utils/Request";
import md5 from "js-md5";
import MyInput from "../../form/MyInput";
import swal from "sweetalert";
import Validators from "../../../utils/Validators";

export default {
  name: "SignUp",
  components: { MyInput },
  data() {
    return {
      email: "",
      password: "",
      rePassword: "",
      agree: true,
      errMsg: "",
      isLoading: false
    };
  },
  methods: {
    signUp() {
      this.errMsg = "";
      if (!this.email || !this.password || !this.rePassword) {
        this.errMsg = "Email and password cannot be empty.";
        return;
      }
      if (!Validators.email(this.email)) {
        this.errMsg = "Incorrect email format.";
        return;
      }
      if (this.password !== this.rePassword) {
        this.errMsg = "Passwords are different, please enter again.";
        return;
      }
      if (!this.agree) {
        this.errMsg = "Please accept the Terms of service and Privacy policy.";
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      request({
        baseURL: process.env.VUE_APP_USER_API_URL,
        url: "/v2/auth/register",
        method: "post",
        data: {
          grant_type: "password",
          username: this.email,
          password: md5(this.password),
          email: this.email,
          country: "CN ",
          time_zone: "Asia/Shanghai "
        }
      })
        .then(response => {
          if (response.code !== 200) {
            this.errMsg = response.msg;
          } else {
            this.email = "";
            this.password = "";
            this.rePassword = "";
            this.errMsg = "";
            swal("Registered successfully.");
            $("#sign-up2sign-in").click();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
